import { CheckSolidIcon, TimesSolidIcon } from '../../../../../assets/icons';
import { useDispatch, useSelector } from '../../../../../store/store';
import { SubscriptionPlans } from '../../../../../configs/payment';
import PlanSkeleton from '../../components/PlanSkeleton';
import Button from '../../../../../components/Button';
import styles from './style.module.scss';
import {
    UNPAID_STATUSES,
    CANCELABLE_STATUSES,
} from '../../constants';
import {
    setPlansModalShow,
    setPaymentRetryMode,
    setChooseCreditCardModal,
    setConfirmCancelSubscriptionModal,
} from '../../../../../store/workspace/slice';
import {
    selectSubscriptionHistory,
    selectFetchingSubscriptionHistory,
} from '../../../../../store/workspace/selectors';

/** The plan the account is on today, with the actions it currently allows. */
export default function PlanInformation() {
    const dispatch = useDispatch();
    const subscription = useSelector(selectSubscriptionHistory);
    const fetching = useSelector(selectFetchingSubscriptionHistory);

    if (fetching) return <PlanSkeleton />;
    if (!subscription) return null;

    const isActive = subscription.status === 'active';
    const isUnpaid = UNPAID_STATUSES.includes(subscription.status);
    const isCancelable = CANCELABLE_STATUSES.includes(subscription.status);

    /** An unpaid subscription is charged again on the card the owner picks. */
    const retryPayment = () => {
        dispatch(setPaymentRetryMode(true));
        dispatch(setChooseCreditCardModal(true));
    };

    return (
        <div className={styles.plan}>
            <span className={styles.plan_title}>Plan Information</span>

            <div className={styles.plan_header} data-has-error={!isActive}>
                <span className={styles.plan_header_name}>
                    {SubscriptionPlans[subscription.plan_name]}
                </span>
                <div className={styles.plan_header_status}>
                    <span>{subscription.status}</span>
                    {isActive ? <CheckSolidIcon /> : <TimesSolidIcon />}
                </div>
            </div>

            <div className={styles.plan_actions}>
                {isUnpaid ? <Button
                    type='Primary'
                    text='Pay now'
                    onClick={retryPayment}
                    className={styles.plan_actions_btn}
                /> : <Button
                    type='Primary'
                    text='Upgrade plan'
                    className={styles.plan_actions_btn}
                    onClick={() => dispatch(setPlansModalShow(true))}
                />}

                {isCancelable && <Button
                    type='Error'
                    text='Cancel'
                    className={styles.plan_actions_btn}
                    onClick={() => dispatch(setConfirmCancelSubscriptionModal(true))}
                />}
            </div>
        </div>
    );
};
